export { default } from "@/features/profile/screens/report-user";
